import styled from "styled-components";

export const SwitchOptionContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	margin-bottom: 10px;
`;

export const SwitchOptionRow = styled.div`
	display: flex;
	align-items: center;
	padding-top: 10px;
	background-color: #ffffff;
	width: fit-content;
	transition: border-color 0.3s, box-shadow 0.3s;

	&:hover {
		border-color: #40a9ff;
	}
`;

export const SwitchLabelStyle: React.CSSProperties = {
	padding: 0,
	fontWeight: "normal",
	fontSize: "15px",
	margin: 0,
	marginBottom: 0,
	color: "#2e333e",
	lineHeight: "1.2",
	display: "block",
};

export const SwitchStyle: React.CSSProperties = {
	width: "80px"
};

export const SwitchHelperTextStyle: React.CSSProperties = {
	margin: "0 0 0 1px",
	fontSize: "12px",
	color: "#6b7280",
	display: "inline"
};
